import type { JSX } from 'react'

export const RemoveIcon = (): JSX.Element => (
  <use href='#removeIcon' height='100%' width='100%' />
)
